import { Component } from '@angular/core';

@Component({
    selector   : 'bh-demo-sidebar',
    templateUrl: './demo-sidebar.component.html',
    styleUrls  : ['./demo-sidebar.component.scss']
})
export class BhDemoSidebarComponent
{
    /**
     * Constructor
     */
    constructor()
    {
    }
}
